// extracted by mini-css-extract-plugin
export default {"movieCell":"movieCard_movieCell__ZJws3","movieImg":"movieCard_movieImg__p1JQZ","movieImgHover":"movieCard_movieImgHover__QSC+K","title":"movieCard_title__xS1yY"};